/**
 * @summary     app.templates.js
 * @description App JS Templates Controller
 * @version     1.3
 	> 1.0 Initial version
  		- 12/01/2015 SG
	> 1.1 Added additional local cacheing mechanism to improve performance
 		- 01/13/2016 SG
	> 1.2 Removed now depricated argument "syncr" from API.set and added comments
		- 01/21/2016 SG
	> 1.3 Made parts of the logic more configurable like paths
		- 07/03/2016 SG
	> 1.4 Added support for module/feature specific folders. We probably need to stop sticking template files all at one level.
		- 10/13/2017	KK
 * @file        app.templates.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 *
 * This source file is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 *
 ** EXAMPLES:
 ** NOTE:
 	This is a simple mechanism by which it will pull down HTML semantic templates and cache them from various sources
 ** TODO:
*/
app.addFeature(
	"templates",
	function (){
		"use strict";

		var saved = {},
			path = "",
			cacheLife = 0,
			prepend = "";

		/*
			Name: get
			Use: API.get()
			Args: temp String - Name of the template
						module String (optional) - Name of module to look in. If not sent, defaults to blank and looks in global templates.
			Description: Retreives a HTML template either from cache or from the server if not in cache
		*/
		function get(temp,module){
			var def = app.deferred(),
				contents;

			module = module || '';

			def.step(
				function(){
					if(!saved[temp]){
						set(temp,module).finished(
							function(){
								def.next(saved[temp].contents);
							}
						);
					}
					else {
						def.next(saved[temp].contents);
					}
				}
			);

			def.step(
				function(res){
					def.results(res);
					def.next();
				}
			);

			return def.begin();
		}

		/*
			Name: set
			Use: API.set()
			Args: temp String - Name of template
						module String - Name of module folder to look in. If blank, looks in global templates.
			Description: Sets a HTML template into temporary cache
		*/
		function set(temp,module){
			var results,
				def = app.deferred();

			// Try to get it from a hidden element's content first, but don't bother if a module was specified.
			if(module === ''){
				def.step(
					function(){
						if(typeof $ === "function"){
                            try {
                                var field = $("#temp-" + temp);

                                if(field.length === 0){
                                    field = $("#" + temp);
                                }

                                results = field.val();

                                // If we're retrieving it we're going to cache it, so remove the DOM element as it's no longer needed
                                if(field.length !== 0){
                                    field[0].parentNode.removeChild(field[0]);
                                }
                            }
                            catch(e){
                                console.log('Could not load local path "#temp-' + temp + ". We will now try to grab it from the server.")
                            }
						}

						def.next();
					}
				);
			}

			// Otherwise retrieve it from the server
			def.step(
				function(){
					if(!results){
						app.ajax.request(
							{
                                url : `${path}${(module !== '' ? module + '/' : prepend )}${temp}.html`,
								cacheLife : cacheLife,
								cacheKeys : [],
								success : function(a){
									results = a.responseText.trim();
									def.next();
								},
								error : function(a){
									results = "";
									def.next();
								},
								method : "GET"
							}
						);
					}
					else {
						def.next();
					}
				}
			);

			def.step(
				function(){
					def.results(results);

					saved[temp] = {
						contents : results,
						named : temp,
						lastUpdated : new Date().getTime()
					};

					def.next();
				}
			);

			return def.begin();
		}

		this.get = get;
		this.set = set;
		this.init = function(){
			cacheLife = app.static.hour * 24;
			return this;
		};

		return this;
	}
);
